module.exports = __webpack_public_path__ + "media/3_24.f22165f5.wav";